import { Component, Input, Output, EventEmitter } from '@angular/core';
import Article from '../../../smoothr-web-app-core/models/Article';
import { PreorderType } from '../../../smoothr-web-app-core/enums/PreorderType';
import { OrderType } from '../../../smoothr-web-app-core/enums/OrderType';
import ArticleGroup from '../../../smoothr-web-app-core/models/ArticleGroup';
import { OrderUtils } from '../../../smoothr-web-app-core/utils/order-utils';
import { environment } from 'src/environments/environment';
import { defaultsToArticleOption, fieldDepositOfArticle, getBasePrice, getPrice, numberD, numberToCurrency } from '../../../smoothr-web-app-core/utils/utils';
import { TOGGLE_TAG } from '../menu-filters/menu-filters.component';
import { TranslateService } from '@ngx-translate/core';
import { ValidationUtils } from 'src/smoothr-web-app-core/utils/validation-utils';
import OptionGroup from 'src/smoothr-web-app-core/models/OptionGroup';
export enum shoGif {
	halbHabl = 'halb_halb',
	buildOwn = 'build_own',
	ownSalate = 'own_salate',
	default = null,
}
@Component({
	selector: 'app-item-view',
	templateUrl: './item-view.component.html',
	styleUrls: ['item-view.component.scss'],
})
export class ItemViewComponent {
	@Input() currency: string;
	@Input() selectedToggleTag: TOGGLE_TAG;
	price: number;
	ot = OrderType;
	environment = environment;
	@Input() hasOrder = false;
	landscape = false;
	priceText = '';
	numberToCurrency = numberToCurrency;
	fromPrice = false;
	showGif = shoGif.default;
	measurmentText: string = '';
	basePrice = '';
	@Output() onCustomize = new EventEmitter<{ article: Article; event: Event }>();
	@Output() onAdd = new EventEmitter<{ article: Article; event: Event }>();
	@Output() onInfo = new EventEmitter<{ article: Article; event: Event }>();

	constructor(
		private translate: TranslateService
	) {}

	private _article: Article;

	get article(): Article {
		return this._article;
	}

	@Input()
	set article(value: Article) {
		this._article = value;
		this.reloadPrice();
		this.showMeasurement(value);
		this.checkMeasurmentPlusPfand(value);

		// Product tracking removed - only track in modal components where users explicitly view details

		// this.checkIfLandscape(value.assets.large)
	}

	private _preorderType: PreorderType = null;

	get preorderType(): PreorderType {
		return this._preorderType;
	}

	@Input()
	set preorderType(value: PreorderType) {
		this._preorderType = value;
		this.reloadPrice();
		this.showMeasurement(this._article);
		this.checkMeasurmentPlusPfand(this._article);
	}
	private minOfItem<T>(items: T[], transformer: (item: T) => number): T {
		if (items.length === 1) {
			return items[0];
		}
		const values = items.map(item => transformer(item));
		const min = Math.min(...values);
		const index = values.indexOf(min);
		return items[index];
	}
	private isDepositOnlyGroup(grp: OptionGroup): boolean {
		const hasDepositTag = this.article?.tags?.some(
			tag => tag.identifier === 'deposit08' || tag.identifier === 'deposit15' || tag.identifier === 'deposit25'
		);
		if (!hasDepositTag) return false;
		if (grp.limit !== 1 || grp.requiredAmount !== 1) return false;
		return !!this.article?.defaults?.some(d => d.group === grp._id);
	}

	private reloadPrice() {
		this.fromPrice = false;
		const articleGroup = new ArticleGroup();
		articleGroup.article = this.article;
		articleGroup.groups = defaultsToArticleOption(this.article, [], [], OrderType.PREORDER, this.preorderType);

		articleGroup.quantity = 1;

		const article = JSON.parse(JSON.stringify(articleGroup.article)) as Article;
		let price = getPrice(article, OrderType.PREORDER, this.preorderType, null);
		const processedGroups: string[] = [];
		if (article?.number) {
			if (article.number == '40144') {
				this.showGif = shoGif.buildOwn;
			}
			if (article.number === '60005') {
				this.showGif = shoGif.halbHabl;
			}
			if (article.number === '40002') {
				this.showGif = shoGif.ownSalate;
			}
		}
		// if (article.groups.length > 0 && article.groups.find(it => it.requiredAmount > 0 && it.visible && it.articles.length > 0)) {
		// }
		if (article && article.tags.length > 0 && article.tags.find(it => it.identifier == 'appliesMostExpensive')) {
			const found = article.groups.find(it => !!it.tags.find(tag => tag.identifier == 'half_pizza'));

			if (found) {
				article.groups = [found];
			}
		}
		article.groups.forEach(grp => {
			if (grp.requiredAmount > 0 && grp.visible && grp.articles.length > 0 && !this.isDepositOnlyGroup(grp)) {
				this.fromPrice = true;
			}
			if (processedGroups.indexOf(grp._id) >= 0) return;
			if (ValidationUtils.isGroupDependencyFulfilled(articleGroup.article, articleGroup.groups, grp).times < 0) return;

			if (grp.requiredAmount == grp.limit) {
				const minimumItem = this.minOfItem(grp.articles, opt => getPrice(opt, OrderType.PREORDER, this.preorderType, null));

				const isTaxItem =
					!!minimumItem.tags?.find(tag => tag.identifier === 'take_away_required') ||
					minimumItem?.name?.de?.toLowerCase().includes('verpackungssteuer');

				if (!isTaxItem && !this.isDepositOnlyGroup(grp)) {
					price += numberD(minimumItem.price) * grp.requiredAmount;
				}

				const dependants = this.dependenciesRegardingOptionArticle(article, article.groups, minimumItem);
				dependants.forEach(dependant => {
					const dependantMinimumItem = this.minOfItem(dependant.articles, opt =>
						getPrice(opt, OrderType.PREORDER, this.preorderType, null)
					);
					price += grp.requiredAmount * dependant.requiredAmount * numberD(dependantMinimumItem.price);
					processedGroups.push(dependant._id);
				});
				processedGroups.push(grp._id);
			}
		});
		// The configured price includes the deposit meta field. The menu shows the base
		// price, with the deposit called out separately as "zzgl. ... Pfand" below.
		price -= fieldDepositOfArticle(article);
		this.price = price;

		// Check for "Ab" tag to add prefix
		const hasAbTag = this.article?.tags && this.article.tags.some(tag => tag.identifier === 'Ab');

		if (hasAbTag || this.fromPrice) {
			this.priceText = this.translate.instant('price_prefix.from') + ' ' + numberToCurrency(this.price, this.currency);
		} else {
			this.priceText = numberToCurrency(this.price, this.currency);
		}
		return;
	}
	dependenciesRegardingOptionArticle(article: Article, groups: OptionGroup[], optionArticle: Article): OptionGroup[] {
		return article.groupDependencies
			.map(gd => {
				if (gd.dependencies.find(dependeci => dependeci.groupArticles.includes(optionArticle._id)) == null) {
					return null;
				} else {
					return groups.find(it => gd.group === it._id);
				}
			})
			.filter(it => !!it);
	}
	// private reloadPrice() {
	// 	if (this.article && this.preorderType) {
	// 		const articleGroup = new ArticleGroup();
	// 		articleGroup.article = this.article;
	// 		articleGroup.groups = defaultsToArticleOption(this.article, [], this.article.defaults, OrderType.PREORDER, this.preorderType);
	// 		articleGroup.quantity = 1;
	// 		this.price = OrderUtils.articleGroupsTotalPrice([articleGroup], OrderType.PREORDER, this.preorderType);
	// 	} else {
	// 		this.price = 0;
	// 	}
	// 	const tagPrice = this.findTagPrice(this.article);

	// 	if (tagPrice && tagPrice > 0) {
	// 		this.price = this.price - tagPrice;
	// 	}
	// 	this.priceText = numberToCurrency(this.price, this.currency);
	// }
	checkIfLandscape(src: string) {
		const image = new Image();
		image.src = src;
		var height = image.height;
		var width = image.width;

		if (width > height) {
			console.log(width, height);
			this.landscape = true;
		}
	}
	hasTag(article: Article) {
		if (!article?.compound?.features) {
			return [];
		}
		const tagArray = [];
		if (article.compound?.features?.vegetarian) {
			tagArray.push('vegetarian');
		}
		if (article.compound?.features?.vegan) {
			tagArray.push('vegan');
		}
		//TODO: test
		if (article?.compound?.additives?.containsAlcohol) {
			tagArray.push('alcohol');
		}
		if (article?.compound?.features?.spicyLevel) {
			tagArray.push('papper');
		}
		return tagArray;
	}
	checkIfOwnPizza(article: Article) {
		return article?.number == '40144';
	}

	showMeasurement(article: Article) {
		if (article && this._preorderType) {
			if (article?.measurement?.refAmount && article?.measurement?.refUnit && article.measurement.amount && this._preorderType) {
				if (article?.measurement?.refAmount == 100 && article?.measurement?.refUnit === 'g') {
					this.basePrice =
						'1' +
						' ' +
						'kg' +
						' = ' +
						numberToCurrency(getBasePrice(article, OrderType.PREORDER, this._preorderType) * 10, this.currency);
					return;
				}
				if (article?.measurement?.refAmount == 100 && article?.measurement?.refUnit === 'ml') {
					this.basePrice =
						'1' +
						' ' +
						'l' +
						' = ' +
						numberToCurrency(getBasePrice(article, OrderType.PREORDER, this._preorderType) * 10, this.currency);
					return;
				}
				this.basePrice =
					article.measurement.refAmount +
					' ' +
					article.measurement.refUnit +
					' = ' +
					numberToCurrency(getBasePrice(article, OrderType.PREORDER, this._preorderType), this.currency);
				return;
			}
		} else {
			return (this.basePrice = '');
		}
	}
	getArticlePrice(article: Article) {
		let totalPrice = getPrice(article, OrderType.PREORDER, this.preorderType);
		const tagPrice = this.findTagPrice(this.article);
		if (tagPrice && tagPrice > 0) {
			totalPrice = totalPrice - tagPrice;
		}
		return totalPrice;
	}
	checkPfandTag(article: Article) {
		if (article.tags?.length === 0) {
			return '';
		}
		const deposit25 = article.tags.find(it => it.identifier === 'deposit25') ? 'deposit25' : '';
		const deposit15 = article.tags.find(it => it.identifier === 'deposit15') ? 'deposit15' : '';
		const deposit8 = article.tags.find(it => it.identifier === 'deposit08') ? 'deposit08' : '';
		const deposit28 = article.tags.find(it => it.identifier === 'deposit28') ? 'deposit28' : '';

		return deposit15 || deposit25 || deposit8 || deposit28;
	}
	checkMeasurmentPlusPfand(article: Article) {
		if (!article || !this.currency) {
			return;
		}
		let result = '';

		const fieldDeposit = fieldDepositOfArticle(article);
		if (fieldDeposit > 0) {
			// The shown price has the deposit taken off, so it is charged on top.
			result =
				this.translate.instant('pfand_text.zzgl') +
				numberToCurrency(fieldDeposit, this.currency) +
				this.translate.instant('pfand_text.pfand') +
				'<br/>';
		} else {
			const pfandValue = this.checkPfandTag(article);
			if (pfandValue) {
				result =
					this.translate.instant('pfand_text.zzgl') +
					numberToCurrency(this.getPricePfandValue(pfandValue), this.currency) +
					this.translate.instant('pfand_text.pfand') +
					'<br/>';
			}
		}

		this.measurmentText = result;
	}

	getPricePfandValue(it: string) {
		if (it === 'deposit25') {
			return 0.25;
		}
		if (it === 'deposit15') {
			return 0.15;
		}
		if (it === 'deposit08') {
			return 0.08;
		}
		if (it === 'deposit28') {
			return 0.28;
		}
		return 0;
	}
	findTagPrice(article: Article) {
		if (article && article.tags && article.tags.length > 0) {
			const foundTag = article?.tags?.find(
				it =>
					it?.identifier === 'deposit25' ||
					it?.identifier === 'deposit15' ||
					it?.identifier === 'deposit08' ||
					it?.identifier === 'deposit28'
			);
			if (foundTag) {
				if (foundTag.identifier === 'deposit25') {
					return 0.25;
				}
				if (foundTag.identifier === 'deposit15') {
					return 0.15;
				}
				if (foundTag.identifier === 'deposit08') {
					return 0.08;
				}
				if (foundTag.identifier === 'deposit28') {
					return 0.28;
				}
				return 0;
			}
			return null;
		} else {
			return null;
		}
	}

	onCustomizeClick(event: Event): void {
		event.stopPropagation();
		this.onCustomize.emit({ article: this._article, event });
	}

	onAddClick(event: Event): void {
		event.stopPropagation();
		this.onAdd.emit({ article: this._article, event });
	}

	onInfoClick(event: Event): void {
		event.stopPropagation();
		this.onInfo.emit({ article: this._article, event });
	}

	isItemInCart(): boolean {
		// This will be implemented to check if item is in the current order
		// For now, return false - this can be enhanced later
		return false;
	}

	hasOptionGroups(): boolean {
		return !!(
			this.article?.groups &&
			this.article.groups.length > 0 &&
			this.article.groups.some(group => group.visible && group.articles && group.articles.length > 0)
		);
	}

	hasForceCustomizeTag(): boolean {
		return !!(this.article?.tags && this.article.tags.some(tag => tag.identifier === 'forceCustomize'));
	}

	hasForceRemovePlusButtonTag(): boolean {
		return !!(this.article?.tags && this.article.tags.some(tag => tag.identifier === 'forceRemovePlusButton'));
	}

	hasDepositTag(): boolean {
		if (!this.article?.tags) {
			return false;
		}
		return this.article.tags.some(
			tag =>
				tag.identifier === 'deposit25' ||
				tag.identifier === 'deposit08' ||
				tag.identifier === 'deposit15' ||
				tag.identifier === 'deposit28' ||
				tag.identifier === 'forceRemoveCustomize'
		);
	}

	shouldShowCustomizeButton(): boolean {
		// Don't show customize button if item has deposit tags
		if (this.hasDepositTag()) {
			return false;
		}
		// Show customize button if item has option groups
		return this.hasOptionGroups();
	}

	shouldShowAddIcon(): boolean {
		// Don't show add icon if item has forceCustomize tag
		if (this.hasForceCustomizeTag()) {
			return false;
		}
		// Don't show add icon if item has forceRemovePlusButton tag
		if (this.hasForceRemovePlusButtonTag()) {
			return false;
		}
		return true;
	}
}
